<mat-form-field subscriptSizing="dynamic">
    @if (ngControl?.control) {
        <input
            matInput
            [placeholder]="placeholder"
            [attr.data-uiid]="dataUiid"
            [formControl]="$any(ngControl!.control)"
            (input)="onChange($event)"
            [errorStateMatcher]="errorMatcher"
        />
    } @else {
        <input
            matInput
            [placeholder]="placeholder"
            [attr.data-uiid]="dataUiid"
            [disabled]="disabled"
            [ngModel]="value"
            (input)="onChange($event)"
        />
    }

    @if (suffixIcon) {
        <mat-icon matSuffix>{{ suffixIcon }}</mat-icon>
    }

    @for (error of ngControl?.control?.errors | errorMessages; track error) {
        <mat-error>{{ error }}</mat-error>
    }
</mat-form-field>
